
import Klapper from "@/components/Klapper.vue";
import {defineComponent} from "vue";
import SliderTO from "@/types/SliderTO";
import Slider from "@/components/rechner/Slider.vue";
import {CalcTrigger} from "@/types/CalcTrigger";
import numberMixin from "@/mixins/NumberMixin";
import ESymbol from "@/enums/ESymbol";

export default defineComponent({
    name: "Sondertilgung",
    components: {Slider, Klapper},
    mixins: [numberMixin],
    data() {
        return {
            isKlapperOpen: false,
        }
    },
    methods: {
        //Setzt die Klasse die die Hintergrundfarbe des offenen Klappers anpasst
        onKlapperTriggered(klapperTriggered: boolean) {
            this.isKlapperOpen = klapperTriggered;
        },
        onSondertilgungChanged(value: number) {
            this.$emit('showErrors', false);
            this.$store.commit(CalcTrigger.SONDERTILGUNG, value);
        },
    },
    computed: {
        sliderSondertilgung(): SliderTO {
            return this.$store.state.sliderSondertilgung;
        },
        isCalculating(): boolean {
            return this.$store.state.isCalculating;
        },
        einsparungBetrag(): string {
            if (this.isCalculating) {
                return "-" + ESymbol.SPACE_HTML + ESymbol.EURO;
            } else if (this.$store.state.berechnungsergebnis && this.$store.state.berechnungsergebnis.sondertilgung) {
                let einsparungKosten = Number(this.$store.state.berechnungsergebnis.sondertilgung.einsparungKosten);
                return this.convertNumberToHtmlWithTwoDigitsAndSuffixEuro(einsparungKosten);
            } else {
                return "";
            }
        },
        einsparungZeit(): string {
            if (this.isCalculating) {
                return "-";
            } else if (this.$store.state.berechnungsergebnis && this.$store.state.berechnungsergebnis.sondertilgung) {
                let laufzeitVerkuerzung = this.$store.state.berechnungsergebnis.sondertilgung.laufzeitVerkuerzung;
                let ausgabeVerkuerzung = "";

                // Wenn sich die Laufzeit nicht verkürzt soll sie auch nicht angezeigt werden, obwohl der Wert vom Backend kommt
                if (!(laufzeitVerkuerzung.jahre == 0 && laufzeitVerkuerzung.monate == 0)) {
                    ausgabeVerkuerzung = laufzeitVerkuerzung.jahre + " Jahre " + laufzeitVerkuerzung.monate + " Monate";
                }
                return ausgabeVerkuerzung;
            } else {
                return ""
            }
        },
        sondertilgungVisible(): boolean {
            return this.$store.state.sondertilgungVisible;
        },
        textKlapperSondertilgung(): string {
            return this.$store.state.fachtexte["rechner.berechnung.text.klapper.sondertilgung"];
        },
        textSliderSondertilgung(): string {
            return this.$store.state.fachtexte["rechner.berechnung.slider.sondertilgung"];
        },
        textToolTipSondertilgung(): string {
            return this.$store.state.fachtexte["rechner.berechnung.tooltip.sondertilgung"];
        },
        textGesparterBetragSondertilgung(): string {
            return this.$store.state.fachtexte["rechner.berechnung.text.gesparter.betrag.sondertilgung"];
        },
        textGesparteLaufzeitSondertilgung(): string {
            return this.$store.state.fachtexte["rechner.berechnung.text.gesparte.laufzeit.sondertilgung"];
        }
    },
    watch: {
        sliderSondertilgung() {
            this.$emit('showErrors', true);
        },
    }
})
